import { linter, lintGutter } from '@codemirror/lint';
import { HtmlValidate } from 'html-validate';
import { css } from '@codemirror/lang-css';

// Create html-validate instance with minimal configuration
const validator = new HtmlValidate({
  rules: {
    'void-style': 'off',
    'no-raw-text': 'off',
    'require-sri': 'off',
    'no-inline-style': 'off',
    'no-missing-references': 'off'
  }
});

// HTML linter function
export const htmlLinter = linter(async (view) => {
  const doc = view.state.doc;
  const text = doc.toString();

  if (!text.trim()) {
    return [];
  }

  try {
    const report = await validator.validateString(text);

    return report.results.flatMap(result =>
      result.messages.map(message => ({
        from: message.offset || 0,
        to: message.offset ? message.offset + 1 : 1,
        message: message.message,
        severity: message.severity === 2 ? 'error' : 'warning'
      }))
    );
  } catch (error) {
    // Return empty array on validation error to avoid breaking the editor
    return [];
  }
});

// CSS linter function using CodeMirror's built-in CSS parser
export const cssLinter = linter((view) => {
  const doc = view.state.doc;
  const text = doc.toString();

  if (!text.trim()) {
    return [];
  }

  const diagnostics = [];
  
  try {
    // Use CodeMirror's CSS parser to detect syntax errors
    const parser = css().language.parser;
    const tree = parser.parse(text);
    
    // Walk the syntax tree to find errors
    tree.iterate({
      enter(node) {
        if (node.type.isError) {
          const from = node.from;
          const to = node.to;
          const errorText = text.slice(from, to);
          
          diagnostics.push({
            from,
            to,
            message: `CSS syntax error ${errorText}`,
            severity: 'error'
          });
        }
      }
    });
  } catch (error) {
    // If parsing fails completely, return empty array
    return [];
  }

  return diagnostics;
});


// Export lintGutter for gutter display
export { lintGutter };
